/**
 * 按钮
 */
import React, {FunctionComponent} from 'react';
import classnames from 'classnames';
import { Button as AButton } from 'antd';
import StylesType from '@/types/StylesType';
import {Omit} from 'antd/lib/_util/type';
import './style';

declare const ButtonTypes: ["default", "primary", "ghost", "dashed", "danger", "link"];
export declare type ButtonType = (typeof ButtonTypes)[number];
declare const ButtonShapes: ["circle", "circle-outline", "round"];
export declare type ButtonShape = (typeof ButtonShapes)[number];
declare const ButtonSizes: ["base", "sm", "lg" ,"xl","xxl"];
export declare type ButtonSize = (typeof ButtonSizes)[number];
declare const ButtonHTMLTypes: ["submit", "button", "reset"];
export declare type ButtonHTMLType = (typeof ButtonHTMLTypes)[number];
export interface BaseButtonProps {
    type?: ButtonType;
    icon?: string;
    shape?: ButtonShape;
    size?: ButtonSize;
    loading?: boolean | {
        delay?: number;
    };
    prefixCls?: string;
    className?: string;
    ghost?: boolean;
    block?: boolean;
    children?: React.ReactNode;
}
export declare type AnchorButtonProps = {
    href: string;
    target?: string;
    onClick?: React.MouseEventHandler<HTMLElement>;
} & BaseButtonProps & Omit<React.AnchorHTMLAttributes<any>, 'type' | 'onClick'>;
export declare type NativeButtonProps = {
    htmlType?: ButtonHTMLType;
    onClick?: React.MouseEventHandler<HTMLElement>;
} & BaseButtonProps & Omit<React.ButtonHTMLAttributes<any>, 'type' | 'onClick'>;
export declare type ButtonProps = Partial<AnchorButtonProps & NativeButtonProps>;


export const Button: FunctionComponent<StylesType & ButtonProps > = props => {
  
    const {children, prefixCls = 'gc-button', className, size} = props;
    const {disabled,ghost,href,htmlType,icon,loading,shape,target,type,onClick,block} = props;
  
    return <AButton
        {...{disabled,ghost,href,htmlType,icon,loading,shape,target,type,onClick,block}}
        className={classnames(prefixCls,className, `${prefixCls}-${size}`)}>{children}</AButton>
  
}

Button.defaultProps = {
    size: 'base'
}

export default Button;
